import link from './link'

export const fields = `
  _type,
  ${link.fragment('contactLink')},
  legal
`

export const fragment = (name = 'footer') => `${name}{${fields}}`

const exported = {
  fields,
  fragment,
}

export default exported
